_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[38],{

/***/ "6FK+":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/price",
      function () {
        return __webpack_require__("WeR+");
      }
    ]);
  

/***/ }),

/***/ "DrxM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Accordion; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;
// デザイナー作成のjsファイルをほぼそのまま流用しているため書き方に違いがあるが、
// 現状メンテナンスは必要なし
 // FIXME dangerouslySetInnerHTMLを使用しているので使用しない様に変更する
// 現在ユーザーが入力するデータには利用していないのでXSSは発生しないが、
// ユーザー入力データを使用する場合はこのComponentを利用してはいけない

/**
 * @deprecated
 * using dangerouslySetInnerHTML
 */

var Accordion = function Accordion(_ref) {
  var id = _ref.id,
      title = _ref.title,
      content = _ref.content;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(''),
      setActive = _useState[0],
      setActiveState = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])('0px'),
      setHeight = _useState2[0],
      setHeightState = _useState2[1];

  var contentRef = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(null);

  var toggleAccordion = function toggleAccordion() {
    var _contentRef$current;

    setActiveState(setActive === '' ? 'active' : '');
    setHeightState(setActive === 'active' ? '0px' : "".concat((_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.scrollHeight, "px"));
  };

  return __jsx("dl", {
    id: id,
    className: "accordion-block ".concat(setActive)
  }, __jsx("dt", {
    onClick: toggleAccordion,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), __jsx("dd", {
    ref: contentRef,
    style: {
      height: "".concat(setHeight)
    }
  }, __jsx("blockquote", {
    dangerouslySetInnerHTML: {
      __html: content
    }
  })));
};

/***/ }),

/***/ "W0p1":
/***/ (function(module) {

module.exports = JSON.parse("[{\"id\":\"price1\",\"question\":\"<h4>新規手配（海外出張）<sup><mark>注4, 5</mark></sup></h4><span>¥3,300</span>\",\"answer\":\"<h5>単位</h5><p>1出張手配ごと、1出張者ごとに発生</p><h5>対象旅行商品</h5><p>国際線航空券、国内線航空券、パッケージツアー、ホテル（企業契約除く）、通信機器、国内・海外送迎、レンタカー、海外鉄道、国内鉄道、フェリーチケット、オプショナルツアー、保険の新規登録手配および出張キャンセルサポート</p>\"},{\"id\":\"price2\",\"question\":\"<h4>新規手配（国内出張）</h4><span>¥1,100</span>\",\"answer\":\"<h5>単位</h5><p>1出張手配ごと、1出張者ごとに発生</p><h5>対象旅行商品</h5><p>国内航空券、ホテル（企業契約除く）、鉄道、パッケージツアー、レンタカー、フェリーチケット、保険の新規登録手配および出張キャンセルサポート</p>\"},{\"id\":\"price3\",\"question\":\"<h4>新規手配（海外出張+国内出張）</h4><span>¥4,400</span>\",\"answer\":\"<h5>単位</h5><p>1出張手配ごと、1出張者ごとに発生</p><h5>対象旅行商品</h5><p>海外出張＋国内出張と同内容</p>\"},{\"id\":\"price4\",\"question\":\"<h4>海外航空券-変更（発券後のみ）</h4><span>¥4,400</span>\",\"answer\":\"<h5>単位</h5><p>変更の都度、チケット単位で発生</p>\"},{\"id\":\"price5\",\"question\":\"<h4>海外航空券-取消（発券後のみ）</h4><span>¥4,400</span>\",\"answer\":\"<h5>単位</h5><p>取消の都度、チケット単位で発生</p>\"},{\"id\":\"price6\",\"question\":\"<h4>海外航空券-緊急発券</h4><span>¥4,400</span>\",\"answer\":\"<h5>単位</h5><p>緊急発券の都度、チケット単位で発生</p><h5>対象旅行商品</h5><p>出発当日及び営業時間外に発券が必要な場合に発生します</p>\"},{\"id\":\"price7\",\"question\":\"<h4>査証代行申請<sup><mark>注6</mark></sup></h4><span>¥6,600</span>\",\"answer\":\"<h5>単位</h5><p>査証申請1件ごと、1名ごとに発生</p>\"},{\"id\":\"price8\",\"question\":\"<h4>企業契約ホテル新規手配（海外）</h4><span>¥1,650</span>\",\"answer\":\"<h5>単位</h5><p>手配の都度、1件ごとに発生</p>\"},{\"id\":\"price9\",\"question\":\"<h4>企業契約ホテル新規手配（国内）</h4><span>¥1,100</span>\",\"answer\":\"<h5>単位</h5><p>手配の都度、1件ごとに発生</p>\"},{\"id\":\"price10\",\"question\":\"<h4>各種予約代行 - 新規手配</h4><span>¥2,200</span>\",\"answer\":\"<h5>単位</h5><p>手配の都度、1件ごとに発生</p><h5>対象旅行商品</h5><p>レストラン予約など</p>\"},{\"id\":\"price11\",\"question\":\"<h4>各種予約代行 - 変更</h4><span>¥1,100</span>\",\"answer\":\"<h5>単位</h5><p>変更の都度、1件ごとに発生</p><h5>対象旅行商品</h5><p>レストラン予約など</p>\"},{\"id\":\"price12\",\"question\":\"<h4>各種予約代行 - 取消</h4><span>¥1,100</span>\",\"answer\":\"<h5>単位</h5><p>取消の都度、1件ごとに発生</p><h5>対象旅行商品</h5><p>レストラン予約など</p>\"},{\"id\":\"price13\",\"question\":\"<h4>その他手配</h4><span class=\\\"no-price\\\">見積り</span>\",\"answer\":\"<h5>単位</h5><p>発生の都度、1件ごとに発生</p><h5>対象旅行商品</h5><p>上記に含まれない手配をおこなう場合又は別途手数料がかかる場合は、手配前に手数料見積もりを提示し、金額了承後に手配をいたします</p>\"}]");

/***/ }),

/***/ "WeR+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Price", function() { return Price; });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("g4pe");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_atoms_Accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DrxM");
/* harmony import */ var _components_templates_NotLoggedIn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("bs2q");
/* harmony import */ var _data_data_price_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("W0p1");
var _data_data_price_json__WEBPACK_IMPORTED_MODULE_4___namespace = /*#__PURE__*/__webpack_require__.t("W0p1", 1);
var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;






var PriceTable = function PriceTable() {
  return __jsx(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null, __jsx("p", null, "\u3053\u3061\u3089\u306E\u8868\u306F\u3001\u5404\u51FA\u5F35\u624B\u914D\u306B\u304B\u304B\u308B\u30C8\u30E9\u30D9\u30EBjp for Business \u5229\u7528\u6599\u306E\u307F\u3092\u8868\u306B\u3057\u305F\u3082\u306E\u3067\u3059\u3002", __jsx("sup", null, __jsx("mark", null, "\u6CE81, 2, 3"))), __jsx("p", null, __jsx("cite", null, "\u3059\u3079\u3066\u7A0E\u8FBC\u307F\u306E\u91D1\u984D\u3067\u3059\u3002")), __jsx("div", {
    className: "policy-price-block"
  }, _data_data_price_json__WEBPACK_IMPORTED_MODULE_4__.map(function (eachPrice, i) {
    return __jsx(_components_atoms_Accordion__WEBPACK_IMPORTED_MODULE_2__[/* Accordion */ "a"], {
      key: i,
      id: eachPrice.id,
      title: eachPrice.question,
      content: eachPrice.answer
    });
  })), __jsx("blockquote", null, __jsx("h4", null, "\u6CE8\uFF09"), __jsx("ol", null, __jsx("li", null, "\u30C8\u30E9\u30D9\u30EBjp for Business \u5229\u7528\u6599\u306F\u3059\u3079\u3066\u7A0E\u8FBC\u307F\u306E\u91D1\u984D\u3067\u3059\u3002\u5229\u7528\u6599\u306F1\u540D\u69D81\u51FA\u5F35\u5358\u4F4D\u3067\u306E\u8AB2\u91D1\u3068\u306A\u308A\u3001\u540C\u4E00\u51FA\u5F35\u5185\u306E\u8907\u6570\u5546\u54C1\u306E\u624B\u914D\u306B\u95A2\u3057\u3066\u3082\u3001\u7247\u9053/\u5F80\u5FA9\u30FB\u533A\u9593\u306B\u95A2\u308F\u3089\u305A\u30011\u540D\u69D81\u51FA\u5F35\u3068\u3057\u3066\u6271\u3044\u307E\u3059\u3002"), __jsx("li", null, "\u4E0A\u8A18\u6599\u91D1\u306F\u65C5\u884C\u3092\u4E2D\u6B62\u3055\u308C\u308B\u5834\u5408\u3067\u3082\u6255\u623B\u3044\u305F\u3057\u307E\u305B\u3093\u3002\u53D6\u6271\u30FB\u5909\u66F4\u624B\u7D9A\u6599\u91D1\u306F\u5F53\u8A72\u624B\u914D\u3092\u53D6\u6D88\u3055\u308C\u308B\u5834\u5408\u3067\u3082\u6255\u623B\u3044\u305F\u3057\u307E\u305B\u3093\u3002"), __jsx("li", null, "\u5909\u66F4\u30FB\u53D6\u6D88\u624B\u7D9A\u6599\u91D1\u306F\u3001\u624B\u914D\u7740\u624B\u5F8C\u306E\u5909\u66F4\u30FB\u53D6\u6D88\u3088\u308A\u7533\u3057\u53D7\u3051\u307E\u3059\u3002"), __jsx("li", null, "\u6D77\u5916\u51FA\u5F35\u3067\u624B\u914D\u3055\u308C\u308B\u56FD\u5185\u7DDA\u822A\u7A7A\u5238\u306F\u3001\u4E57\u7D99\u79FB\u52D5\u306B\u8A72\u5F53\u3059\u308B\u540C\u65E5\u5185\uFF0824\u6642\u9593\uFF09\u624B\u914D\u306E\u822A\u7A7A\u5238\u3068\u306A\u308A\u307E\u3059\u3002\u65E5\u3092\u8DE8\u3050\u5229\u7528\u65E5\u306E\u56FD\u5185\u7DDA\u822A\u7A7A\u5238\u306B\u95A2\u3057\u3066\u306F\u300E\u6D77\u5916\u51FA\u5F35\uFF0B\u56FD\u5185\u51FA\u5F35\u300F\u306E\u9805\u76EE\u3068\u306A\u308A\u3001\u898F\u5B9A\u306E\u624B\u6570\u6599\u3092\u7533\u3057\u53D7\u3051\u307E\u3059\u3002"), __jsx("li", null, "\u6D77\u5916\u51FA\u5F35\u3067\u56FD\u969B\u822A\u7A7A\u5238\u4E26\u3073\u306B\u5BBF\u6CCA\u306E\u624B\u914D\u304C\u4F34\u308F\u306A\u3044\u3001\u901A\u4FE1\u6A5F\u5668\u3068\u4FDD\u967A\u5358\u54C1\u306E\u624B\u914D\u306F\u56FD\u5185\u51FA\u5F35\u6271\u3044\u3068\u3057\u3066\u5229\u7528\u6599\u3092\u7533\u3057\u53D7\u3051\u307E\u3059\u3002"), __jsx("li", null, "\u67FB\u8A3C\u7533\u8ACB\u8CBB\u7528\u306F\u5225\u9014\u7533\u3057\u53D7\u3051\u307E\u3059\u3002"))));
};

var Price = function Price() {
  return __jsx(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null, __jsx(_components_templates_NotLoggedIn__WEBPACK_IMPORTED_MODULE_3__[/* NotLoggedIn */ "a"], null, __jsx(next_head__WEBPACK_IMPORTED_MODULE_0___default.a, null, __jsx("title", null, "\u30C8\u30E9\u30D9\u30EBjp for Business \u5229\u7528\u6599")), __jsx("div", {
    className: "page-title"
  }, __jsx("section", null, __jsx("h1", null, "\u30C8\u30E9\u30D9\u30EBjp for Business \u5229\u7528\u6599"))), __jsx("section", {
    id: "price"
  }, __jsx(PriceTable, null))));
};
/* harmony default export */ __webpack_exports__["default"] = (Price);

/***/ }),

/***/ "bs2q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotLoggedIn; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _components_organisms_commons_Footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("UzZs");
/* harmony import */ var _components_organisms_commons_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("AhNQ");
/* harmony import */ var _hooks_common_usePageSpecificCSS__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("VVAR");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var NotLoggedIn = function NotLoggedIn(_ref) {
  var children = _ref.children;

  var _usePageSpecificCSS = Object(_hooks_common_usePageSpecificCSS__WEBPACK_IMPORTED_MODULE_3__[/* usePageSpecificCSS */ "a"])('common'),
      CSSLinkTag = _usePageSpecificCSS.CSSLinkTag,
      isLoadingCSS = _usePageSpecificCSS.isLoadingCSS;

  return __jsx(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, CSSLinkTag, !isLoadingCSS && __jsx("div", null, __jsx(_components_organisms_commons_Header__WEBPACK_IMPORTED_MODULE_2__[/* Header */ "a"], null), __jsx("main", null, children, __jsx(_components_organisms_commons_Footer__WEBPACK_IMPORTED_MODULE_1__[/* Footer */ "a"], null))));
};

/***/ })

},[["6FK+",0,1,2,3,4]]]);